// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1w-0";
export var spinnerContainer = "_1w-1";